import React, {useState, useEffect} from 'react';
import {isUrlLoaded, loadUrl} from '../utils/helpers/imageCache';

interface ImageType extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    src: string;
    min?: string;
    thu?: string;
    alt: string;
    className?: string;
}

export const ProgressiveImage: React.FC<ImageType> = ({src, min, thu, alt, className = '', ...props}) => {
    const [imgSrc, setImgSrc] = useState(() => (isUrlLoaded(src) ? src : thu || min || src));

    useEffect(() => {
        if (!min) return;
        let cancelled = false;
        loadUrl(min).then(() => {
            if (!cancelled) setImgSrc(min);
        });
        return () => {
            cancelled = true;
        };
    }, [min]);

    useEffect(() => {
        let cancelled = false;
        loadUrl(src).then(() => {
            if (!cancelled) setImgSrc(src);
        });
        return () => {
            cancelled = true;
        };
    }, [src]);

    return <img {...{src: imgSrc, ...props}} className={className + (min && imgSrc === src ? ' loaded' : ' loading')} alt={alt} />;
};
